<template>
  <div v-if="showRemindInfo" class="remind-wrapper" @click.stop="">
    <div class="remind">
      <img src="@/images/addCart/remindAlert.png" class="remind-img" />

      <div class="remind-text">
        您正在加购
        <span class="remind-text-date">非上午送达</span>
        的商品，请关注蓝色标签中商品的配送时间哦
      </div>

      <div class="remind-operate" @click="select">
        <IconFont
          v-if="isSelect"
          name="xuankuang-gouxuan"
          color="#15bb5c"
          size="20px"
        />
        <IconFont
          v-else
          name="xuankuang-weixuanzhong"
          color="#15bb5c"
          size="20px"
        />
        <span class="remind-operate-text">不再提醒我</span>
      </div>

      <div class="remind-ok" @click="closeClick">我知道了</div>
    </div>
  </div>
</template>

<script>
import tracerVuePlugin from '@mc/tracer-vue-plugin'
import { companyId } from '@/defines/user'
export default {
  name: 'RemindAlert',
  data() {
    return {
      isSelect: false,
      showRemindInfo: false
    }
  },
  mounted() {
    const remindRemark = localStorage.getItem('MC_REMIND_ALERT_REMARK') || ''
    if (remindRemark === 'never') return
    if (remindRemark === this._formatDateMD()) return

    tracerVuePlugin.request({
      spm: 'n.4683.9734.0',
      type: 8,
      params: {
        company_id: companyId
      },
      page_id: 4683
    })
    this.showRemindInfo = true
  },
  methods: {
    select() {
      // 埋点
      this.$track(this.isSelect ? 'n.4683.9736.0' : 'n.4683.9735.0')
      this.isSelect = !this.isSelect
    },
    closeClick() {
      localStorage.setItem(
        'MC_REMIND_ALERT_REMARK',
        this.isSelect ? 'never' : this._formatDateMD()
      )
      this.showRemindInfo = false
      // 埋点
      this.$track('n.4683.9737.0')
    },
    _formatDateMD() {
      const timeTemp = new Date()
      return `${timeTemp.getMonth() + 1}.${timeTemp.getDate()}`
    }
  }
}
</script>

<style lang="scss" scoped>
.remind-wrapper {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 999;

  background-color: rgba(0, 0, 0, 0.6);

  .remind {
    position: absolute;
    top: 50%;
    left: 50%;

    transform: translate(-50%, -50%);

    width: 5.9rem;

    background-color: #fff;

    border-radius: 0.16rem;

    &-img {
      display: block;

      width: 5.26rem;
      height: 2.1rem;
      margin: 0.32rem auto;
    }
    &-text {
      padding: 0 0.4rem;

      line-height: 0.36rem;
      @include text(0.28rem, #595959);

      &-date {
        color: #15bb5c;
      }
    }

    &-operate {
      padding: 0.44rem 0.4rem 0.3rem;
      @include flex(row, normal, center);
      @include text(0.28rem, #595959);
      &-text {
        padding-left: 0.2rem;
      }
    }

    &-ok {
      height: 1.12rem;

      border-top: 0.01rem solid #f5f5f5;

      line-height: 1.12rem;
      text-align: center;
      @include text(0.32rem, #15bb5c);
    }
  }
}
</style>
